import React from "react";
import "./Footer.css";

export default function Footer({ navigate, showComingSoon }) {
  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* Brand */}
        <div className="footer-brand">
          <div className="footer-logo">
            <div className="logo-mark">RD</div>
            <div className="logo-text">
              RoadDogg<span> AI</span>
            </div>
          </div>
          <p>
            Your intelligent co-pilot on every journey. Smarter navigation,
            cleaner records, safer travels.
          </p>
          <div className="footer-app-btns">
            <a
              href="#"
              className="app-store-btn"
              onClick={(e) => {
                e.preventDefault();
                showComingSoon();
              }}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              <span className="asb-text">
                <span className="small">Coming Soon</span>
                <span className="big">App Store</span>
              </span>
            </a>
            <a
              href="#"
              className="app-store-btn"
              onClick={(e) => {
                e.preventDefault();
                showComingSoon();
              }}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M3.18 23.76c.3.17.64.22.97.16l12.09-6.98-2.56-2.55-10.5 9.37zM20.65 9.29L17.3 7.35 14.43 10l3.03 3.03 3.21-1.85c.91-.52.91-1.95-.02-2.89zM2.25.14C1.96.42 1.78.86 1.78 1.43v21.09c0 .58.18 1.01.48 1.28l.07.06 11.81-11.81v-.28L2.32.08 2.25.14zM3.18.19l12.09 6.98-2.56 2.55L2.21.35c.3-.17.64-.22.97-.16z" />
              </svg>
              <span className="asb-text">
                <span className="small">Coming Soon</span>
                <span className="big">Google Play</span>
              </span>
            </a>
          </div>
        </div>

        {/* App links */}
        <div className="footer-col">
          <h4>App</h4>
          <ul>
            <li>
              <a onClick={() => navigate("home")}>Home</a>
            </li>
            <li>
              <a onClick={() => navigate("about")}>About</a>
            </li>
            <li>
              <a onClick={() => navigate("support")}>Support</a>
            </li>
          </ul>
        </div>

        {/* Legal links */}
        <div className="footer-col">
          <h4>Legal</h4>
          <ul>
            <li>
              <a onClick={() => navigate("privacy")}>Privacy Policy</a>
            </li>
            <li>
              <a onClick={() => navigate("terms")}>Terms &amp; Conditions</a>
            </li>
            <li>
              <a onClick={() => navigate("support")}>Contact Us</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 RoadDogg AI. All rights reserved.</p>
        <p>
          RoadDogg AI is a product of{" "}
          <strong style={{ color: "rgba(255,255,255,0.5)" }}>
            Kustom Habitz LLC
          </strong>
          .
        </p>
      </div>
    </footer>
  );
}
